import { render } from "./TheHeader.vue?vue&type=template&id=2b0bf2b2"
const script = {}
script.render = render

export default script